import type { ReactNode } from "react";
import { useIsMobile } from "../lib/useIsMobile";

interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageHeader({ eyebrow, title, subtitle, action }: Props): React.JSX.Element {
  const isMobile = useIsMobile();
  return (
    <header
      style={{
        marginBottom: isMobile ? 20 : 28,
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "stretch" : "flex-end",
        justifyContent: "space-between",
        gap: isMobile ? 14 : 24,
      }}
    >
      <div>
        {eyebrow && (
          <div
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: "var(--ql-yellow)",
              textTransform: "uppercase",
              letterSpacing: ".10em",
              marginBottom: 8,
            }}
          >
            {eyebrow}
          </div>
        )}
        <h1 style={{ fontSize: isMobile ? 24 : 30, fontWeight: 800, margin: 0, letterSpacing: "-0.025em" }}>{title}</h1>
        {subtitle && (
          <p style={{ marginTop: 6, marginBottom: 0, color: "var(--ql-fg-muted)", fontSize: 14, maxWidth: 580 }}>
            {subtitle}
          </p>
        )}
      </div>
      {action}
    </header>
  );
}
